<template>
  <ProductPage
    :theme="theme"
    :page-meta="pageMeta"
    :sections="sections"
    :features="features"
    :architecture="architecture"
    :why-us="whyUs"
    :scenarios="scenarios"
    :related-products="relatedProducts"
    contact-path="/comprehensive-governance"
    default-product="综合治理系统"
  />
</template>

<script>
import ProductPage from '../components/ProductPage.vue'
import {
  theme,
  pageMeta,
  sections,
  features,
  architecture,
  whyUs,
  scenarios,
  relatedProducts
} from '../data/comprehensive-governance'

export default {
  name: 'ComprehensiveGovernance',
  components: { ProductPage },
  data() {
    return {
      theme,
      pageMeta,
      sections,
      features,
      architecture,
      whyUs,
      scenarios,
      relatedProducts
    }
  }
}
</script>
